import React from "react";
import _ from "lodash";
import anime from "animejs";
import styled from "styled-components";

import { isIE } from "../../utils/detector";

// const bounce = keyframes`
//   0% {
//     transform: translateY(0);
//   }

//   100% {
//     transform: translateY(-5px);
//   }
// `;

// const AnimatedPin = styled.g`
//   ${props => props.animated && css`animation: ${bounce} 0.4s infinite ease alternate;`}
//   animation-delay: ${Math.random}s;
// `;

const AnimatedScaledG = styled.g`
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transform-origin: 50% 100%;
`;

const AnimatedBubble = styled.g`
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
`;

const Bubble = styled.image.attrs({
  x: 10,
  y: 4,
  height: 40,
})``;

const fixIETransform = (el) => (anim) => {
  if (el) {
    const transform = getComputedStyle(el).getPropertyValue("transform");
    el.setAttribute("transform", transform);
  }
};

class Marker extends React.Component {
  render() {
    const { width, label, color, visible } = this.props;
    return (
      <svg
        viewBox="0 0 81 109"
        x={-0.5 * width}
        y={-1.5 * width}
        width={width}
        height={1.5 * width}
      >
        <AnimatedScaledG transform={`scale(${visible ? 1 : 0})`}>
          <path
            fill={color}
            d="M81,40.5C81,72,40.83,109,40.83,109S0,71,0,40.5a40.5,40.5,0,0,1,81,0Z"
          />
          {label && (
            <text
              x={40}
              y={60}
              textAnchor="middle"
              fill="white"
              style={{ fontSize: 40 }}
            >
              {label}
            </text>
          )}
        </AnimatedScaledG>
      </svg>
    );
  }
}

export default class extends React.PureComponent {
  constructor(props) {
    super(props);
    this.gref = React.createRef();
  }
  componentDidMount() {
    if (this.props.animated) {
      anime({
        targets: this.gref.current,
        translateY: [0, -5],
        loop: true,
        // delay: (el, i, l) => {
        //   return Math.random() * 1000;
        // },
        direction: "alternate",
        duration: 1600,
        ease: "easeOutExpo",
        update: isIE ? fixIETransform(this.gref.current) : null,
      });
    }
  }

  // componentWillUnmount() {
  //   this.bouncingTween.kill();
  // }
  render() {
    const {
      x,
      y,
      label,
      color,
      bubble,
      renderPin,
      onClick,
      showDot = false,
      visible = true,
      markerWidth = 20,
    } = this.props;
    return (
      <g
        transform={`translate(${x} ${y})`}
        style={{ cursor: "pointer" }}
        onClick={(e) => onClick(this.props)}
      >
        {showDot && <circle cx={0} cy={0} r={5} fill="red" />}
        <g ref={this.gref} transform="translate(0, 0)">
          {typeof renderPin === "function" ? (
            renderPin(this.props)
          ) : (
            <Marker
              width={markerWidth}
              label={label}
              color={color}
              visible={visible}
            />
          )}
        </g>
        {bubble && (
          <AnimatedBubble
            transform={`translate(${bubble.x !== undefined ? bubble.x : 14} ${
              bubble.y !== undefined ? bubble.y : -55
            }) scale(${visible ? 1 : 0})`}
          >
            <rect
              className="bubble-logo"
              x={0}
              y={0}
              width={20 + (32 * bubble.width) / bubble.height}
              height={40}
              rx={20}
              ry={20}
              fill={color}
            />
            {typeof bubble.render === "function" ? (
              bubble.render(_.omit(bubble, ["render"]), this.props)
            ) : (
              <Bubble
                xlinkHref={bubble.url}
                width={(32 * bubble.width) / bubble.height}
                height={32}
              />
            )}
          </AnimatedBubble>
        )}
      </g>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/svg/Pin.js